export default "__VITE_ASSET__BH01aeCN__"